import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import ProfilePicture from '@/components/ui/profile-picture';
import { UserState } from '@/redux/auth/auth';
import gradientBg from '@/assets/gradient-bg.png';

function PostCommentFormHeader() {
  const { isAuthenticated, user } = useSelector(
    (state: { auth: UserState }) => state.auth
  );

  if (user && isAuthenticated) {
    return (
      <Link to={`/${user.username}`}>
        <div className="flex items-center gap-5">
          <ProfilePicture
            className="w-10 h-10"
            src={user.profilePicture}
            alt={user.firstname}
          />
          <span className="text-xl text-[#000] font-primary font-medium">
            @{user.username}
          </span>
        </div>
      </Link>
    );
  }

  return (
    <div
      className="h-[72px] w-full bg-cover bg-center flex items-center justify-center overflow-hidden rounded-md"
      style={{ backgroundImage: `url(${gradientBg})` }}
    >
      <h1 className="font-primary font-medium text-xl leading-[26px] text-[#FFFFFF]">
        Whoops! You’re Missing out..
      </h1>
    </div>
  );
}

export default PostCommentFormHeader;
